export const store = $state({
    translations: [],
    languages: [],
    categories: [],
    places: [],
    get explodedCategories() {
        return explodeCategory(this.categories, null, 0);
    }
});

var currentLanguage = $state(null);

export const language = $state({
    get current() {
        return currentLanguage;
    },
    set current(lang) {
        currentLanguage = lang;
        // document.documentElement.setAttribute('lang', $navigating.to.params.lang);
        document.documentElement.setAttribute('dir', lang.dir);
    }
});

function explodeCategory(categories, parent, indent)
{
    let ret = [];

    categories.forEach((c) => {
        const copy = {
            ...c,
            parent: parent,
            indent: indent,
            default_name: c.names[1]
        };

        ret.push(copy);

        if (copy.children.length > 0) {
            let children = explodeCategory(copy.children, copy, indent + 1);
            ret = ret.concat(children);
        }
    });

    return ret;
}

export function deleteCategory(categories, target)
{
    return categories.every((category, index) => {
        if (category.children.length > 0) {
            return deleteCategory(category.children, target);
        }
        else {
            if (category.id == target.id) {
                categories.splice(index, 1);
                return false;
            }
        }

        return true;
    });
}
